import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
// import VueGtag from 'vue-gtag'
import VueNoty from 'vuejs-noty'
import 'vuejs-noty/dist/vuejs-noty.css'
import i18n from './i18n'
import ScrollAnimation from './directives/scrollanimation'
import backgroundanimation from './directives/backgroundanimation'
import backgroundanimationrevret from './directives/backgroundanimationrevret'
import { applyRouteMeta } from './utils/seo'

Vue.config.productionTip = false
Vue.directive('scrollanimation', ScrollAnimation);
Vue.directive('backgroundanimation', backgroundanimation);
Vue.directive('backgroundanimationrevret', backgroundanimationrevret);

// google analytics disabled 12.01.23
// Vue.use(VueGtag, {
//     appName: 'AGH Solar Boat',
//     config: {
//         id: 'G-4ZHY3RN09Q'
//     },
//     pageTrackerScreenviewEnabled: true
// }, router)

Vue.use(VueNoty, {
    timeout: 3500,
    theme: 'mint',
    layout: 'bottomLeft'
})

const app = new Vue({
    vuetify,
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')

router.onReady(() => {
    applyRouteMeta(router.currentRoute, app)
})
